import axios from "axios";
import { ENDPOINTS } from "../../apiConstants";
import { getConfigDelete, getConfigGet, getConfigPatch, getConfigPost } from "../../getConfig";

export const CLO_NETWORKS = ["visa", "mastercard"];
export const CLO_CHANNELS = ["online", "in_store", "delivery", "click_and_collect", "marketplace"];
export const MATCH_TYPES: Record<string, string> = {
  starts_with: "Starts with",
  contains: "Contains",
  regex: "Regular expression",
};
export const HOLDOUT_SHARES_BP = [200, 500, 1000];
export const RULE_TYPES: Record<string, string> = {
  A: "A · % of spend",
  B: "B · % above/below a fixed £ threshold",
  C: "C · fixed £ amount",
  D: "D · % above customer's median basket",
  E: "E · different per channel",
  F: "F · tiered %",
};
export const FEE_TYPES: Record<string, string> = {
  M1: "M1 · % of spend",
  M2: "M2 · % of qualifying spend",
  M3: "M3 · fixed £ per purchase",
  M4: "M4 · % above/below a fixed £ threshold",
  M5: "M5 · tiered %",
};
export const RULE_TEMPLATES: Record<string, object> = {
  A: { rateBp: 1000 },
  B: { direction: "above", thresholdMinor: 2500, rateBp: 200 },
  C: { fixedMinor: 1000, minimumMinor: 10000 },
  D: { rateBp: 200 },
  E: {
    channels: {
      in_store: { ruleType: "A", ruleParams: { rateBp: 500 }, feeType: "M1", feeParams: { rateBp: 200 } },
      delivery: { ruleType: "A", ruleParams: { rateBp: 300 }, feeType: "M1", feeParams: { rateBp: 200 } },
    },
  },
  F: { bands: [{ belowMinor: 5000, rateBp: 200 }, { belowMinor: null, rateBp: 500 }] },
};
export const FEE_TEMPLATES: Record<string, object> = {
  M1: { rateBp: 400 },
  M2: { rateBp: 100 },
  M3: { fixedMinor: 200 },
  M4: { direction: "above", thresholdMinor: 2500, rateBp: 100 },
  M5: { bands: [{ belowMinor: 5000, rateBp: 100 }, { belowMinor: null, rateBp: 200 }] },
};

export const cloGet = async (url: string, params: any = {}) => (await axios.get<any>(url, getConfigGet(params))).data;
export const cloPost = async (url: string, body: any) => (await axios.post<any>(url, body, { headers: getConfigPost() })).data;
export const cloPatch = async (url: string, body: any) => (await axios.patch<any>(url, body, { headers: getConfigPatch() })).data;
export const cloDelete = async (url: string) => (await axios.delete<any>(url, { headers: getConfigDelete() })).data;

export const cloUpload = async (url: string, form: FormData) => {
  const accessToken = localStorage.getItem("accessToken") || "";
  return (await axios.post<any>(url, form, { headers: { Authorization: `Bearer ${accessToken}` } })).data;
};

export const cloError = (e: any): string => {
  const data = e?.response?.data;
  const raw = data?.data?.errors ?? data?.errors;
  const nested = raw?.errors ?? raw;
  const list = Array.isArray(nested) ? nested : nested && typeof nested === "object" ? Object.values(nested) : [];
  const details: string[] = list.map((d: unknown) => String(d).replaceAll('"', ""));
  const message = data?.message || e?.message || "Something went wrong";
  return details.length ? `${message}: ${details.join("; ")}` : message;
};

export const pounds = (minor: number | string | null | undefined): string =>
  minor === null || minor === undefined || minor === "" ? "—" : `£${(Number(minor) / 100).toFixed(2)}`;

export const percent = (bp: number | string | null | undefined): string =>
  bp === null || bp === undefined ? "—" : `${Number(bp) / 100}%`;

export const toMinor = (value: string): number | null => (value.trim() === "" ? null : Math.round(Number(value) * 100));

export const fromMinor = (minor: number | string | null | undefined): string =>
  minor === null || minor === undefined ? "" : String(Number(minor) / 100);

export const formatDate = (value: string | null | undefined): string =>
  value ? new Date(value).toLocaleString("en-GB") : "—";

export { ENDPOINTS };
